// src/pages/Contact.js
import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        {/* عنوان اصلی */}
        <h1 className="text-4xl md:text-5xl font-bold text-center text-gold-dark mb-6" data-aos="fade-down">
          ارتباط با ما
        </h1>
        <p className="text-center text-lg md:text-xl text-gray-600 mb-16 max-w-3xl mx-auto" data-aos="fade-up">
          از طریق روش‌های زیر با ما در تماس باشید
        </p>

        {/* کارت‌های ارتباط */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {/* واتساپ */}
          <div className="bg-white rounded-2xl shadow-xl p-8 text-center hover:shadow-2xl transition transform hover:-translate-y-2" data-aos="fade-up">
            <div className="text-6xl mb-4 text-green-600">
              <i className="bi bi-whatsapp"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">واتساپ</h3>
            <p className="text-gray-600 mb-6">پاسخ سریع در واتساپ</p>
            <a
              href="https://wa.me/989215316012"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-xl transition"
            >
              ارسال پیام
            </a>
          </div>

          {/* اینستاگرام */}
          <div className="bg-white rounded-2xl shadow-xl p-8 text-center hover:shadow-2xl transition transform hover:-translate-y-2" data-aos="fade-up" data-aos-delay="200">
            <div className="text-6xl mb-4 text-pink-600">
              <i className="bi bi-instagram"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">اینستاگرام</h3>
            <p className="text-gray-600 mb-6">ما را در اینستاگرام دنبال کنید</p>
            <a
              href="https://instagram.com/Khorrami.gallery"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-pink-600 hover:bg-pink-700 text-white font-bold py-3 px-8 rounded-xl transition"
            >
              مشاهده صفحه
            </a>
          </div>

          {/* تلفن تماس */}
          <div className="bg-white rounded-2xl shadow-xl p-8 text-center hover:shadow-2xl transition transform hover:-translate-y-2" data-aos="fade-up" data-aos-delay="400">
            <div className="text-6xl mb-4 text-blue-600">
              <i className="bi bi-telephone"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">تلفن تماس</h3>
            <p className="text-gray-600 mb-3">پاسخگویی از ساعت ۹ تا ۱۳ و ۱۷ تا ۲۱</p>
            <a
              href="tel:03132222042"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-xl transition"
            >
              تماس با ما
            </a>
          </div>
        </div>

        {/* آدرس و نقشه */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 mb-12" data-aos="fade-up">
          <h2 className="text-3xl font-bold text-center text-gold-dark mb-8">آدرس ما</h2>
          <p className="text-center text-lg text-gray-700 mb-8 leading-relaxed">
            اصفهان، خیابان چهارباغ عباسی، بازار هنر، گالری طلا و جواهر خرمی
          </p>

          {/* نقشه گوگل */}
          <div className="map-container rounded-2xl overflow-hidden shadow-lg">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3400.000000000000!2d51.6688836!3d32.6523385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzLCsDM5JzA4LjIiTiA1McKwNDAnMDguMCJF!5e0!3m2!1sfa!2sir!4v1630000000000!5m2!1sfa!2sir"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="نقشه گالری خرمی"
            ></iframe>
          </div>
        </div>

        {/* تاریخچه کوتاه */}
        <div className="text-center text-gray-700 max-w-4xl mx-auto" data-aos="fade-up">
          <h2 className="text-3xl font-bold text-gold-dark mb-6">تاریخچه گالری</h2>
          <p className="text-lg leading-relaxed mb-6">
            گالری طلا و جواهری خرمی با افتخار از <strong>سال ۱۳۵۰</strong> در بازار هنر، با مدیریت <strong>حاج بهرام خرمی</strong> و با برند «گالری خرم» آغاز به کار کرد. این برند قدیمی، هم‌اکنون با نام <strong>«گالری طلا و جواهری خرمی»</strong> و با مدیریت <strong>محسن خرمی</strong>، با افتخار در حال خدمت‌رسانی به مشتریان وفادار و جذب مشتریان جدید است.
          </p>
          <ul className="list-disc list-inside text-right space-y-3 text-lg">
            <li><strong>سال ۱۳۵۰:</strong> آغاز فعالیت با مدیریت حاج بهرام خرمی در بازار هنر.</li>
            <li><strong>دهه ۱۳۷۰:</strong> توسعه فعالیت‌ها و افزایش تنوع محصولات.</li>
            <li><strong>دهه ۱۳۸۰:</strong> ارائه طراحی‌های اختصاصی و سفارشی.</li>
            <li><strong>سال ۱۳۹۵:</strong> انتقال مدیریت به محسن خرمی و نوسازی برند.</li>
            <li><strong>سال ۱۴۰۰ به بعد:</strong> آغاز فروش آنلاین و خدمات دیجیتال.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;